var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.status)?_c('div',{staticClass:"d-flex align-items-center"},[_c('span',{staticClass:"avisoDanger"},[_vm._v(_vm._s(_vm.mensagem))]),_c('b-spinner',{class:_vm.cssClass,attrs:{"variant":"danger"}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }